import { BaseApi } from './base.api.js';

export class BackupApi extends BaseApi {
    constructor(client) {
        super(client, '/backup');
    }

    list() {
        return this.client.get(this.basePath).then((r) => r.data);
    }

    run(body = {}) {
        return this.client.post(`${this.basePath}/run`, body).then((r) => r.data);
    }

    pbmList() {
        return this.client.get(`${this.basePath}/pbm`).then((r) => r.data);
    }

    pbmStatus() {
        return this.client.get(`${this.basePath}/pbm/status`).then((r) => r.data);
    }

    pbmRun(body = {}) {
        return this.client.post(`${this.basePath}/pbm/run`, body).then((r) => r.data);
    }

    pbmRestore(body = {}) {
        return this.client.post(`${this.basePath}/pbm/restore`, body).then((r) => r.data);
    }

    pbmDelete(body = {}) {
        return this.client.post(`${this.basePath}/pbm/delete`, body).then((r) => r.data);
    }

    pbmResync() {
        return this.client.post(`${this.basePath}/pbm/resync`, {}).then((r) => r.data);
    }

    getSchedule() {
        return this.client.get(`${this.basePath}/schedule`).then((r) => r.data);
    }

    updateSchedule(body) {
        return this.client.put(`${this.basePath}/schedule`, body).then((r) => r.data);
    }

    testStorage() {
        return this.client.post(`${this.basePath}/storage/test`, {}).then((r) => r.data);
    }

    updateStorage(body) {
        return this.client.put(`${this.basePath}/storage`, body).then((r) => r.data);
    }
}
